import { formatText } from 'lib/textHelper'

export default function(text) {
  const $dom = $(formatText(text))
  const textWithoutLinks = $dom.find('a').remove().end().text()

  return textWithoutLinks.trim() !== ''
}
